var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("jListCompanyLocation", {
        ref: "locationTable",
        on: {
          "edit-modal": _vm.openModalUpdate,
          "create-modal": _vm.openModalCreate,
          "detail-location": _vm.getLocationDetail
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalForm",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            [
              _vm.isOpen
                ? _c("j-form-company-location", {
                    attrs: { mode: _vm.mode, detail: _vm.company_location },
                    on: {
                      updated: _vm.refreshList,
                      "close-modal": _vm.closeModalForm
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c43b210", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c43b210","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/location/jCompanyLocation.vue
// module id = null
// module chunks = 